module.exports = __webpack_public_path__ + "static/media/3.c6865673.jpg";